import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { KalenderMitarbeiterStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/KalenderStation';

export class KalenderMitarbeiter {
  constructor({
    id,
    vorname,
    nachname,
    beruf,
    stationen,
    imgUrl,
    lehrjahr,
  }: {
    id: string;
    vorname: string;
    nachname: string;
    beruf: Beruf;
    stationen?: KalenderMitarbeiterStation[];
    imgUrl?: string;
    lehrjahr: string;
  }) {
    this.id = id;
    this.vorname = vorname;
    this.nachname = nachname;
    this.beruf = beruf;
    this.stationen = stationen;
    this.imgUrl = imgUrl;
    this.lehrjahr = lehrjahr;
  }

  id: string;
  vorname: string;
  nachname: string;
  beruf: Beruf;
  stationen?: KalenderMitarbeiterStation[];
  lehrjahr: string;
  imgUrl?: string;
}
